module.exports = __webpack_public_path__ + "img/product_7.d90f5b9.webp";